<script>
    import { scale, fade, fly, slide } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';
    import { onMount, onDestroy } from 'svelte';
    import { get } from 'svelte/store';

    import { user } from '../store/authStore';
    import { page, modal } from '../store/nav';
    import { lists } from '../store/lists';
    import { items, categories } from "../store/items";

    import { idb } from '../db';

    import Icon from '../components/icon.svelte';

    export let list_uid;
    export let back_nav = false;

    let categoriesInList = {};
    let itemCollected=0;
    let progress=0;
    let menuClick = false;

    let itemCollectionStatus = [
        "it_none",
        "it_collected",
        "it_skipped"
    ];

    onMount(async () => {
        console.group(`INFO: /lists/items .onMount`);
        await lists.init(list_uid)
		await items.init(list_uid, `listUid`);
       
        console.log(`$lists`);console.log($lists);
        console.log(`$items`);console.log($items);
        console.log(`$categories`);console.log($categories);
        console.groupEnd();                   
	});    

    const changeItemStatus = async (uid, status) => {
        const next_status = ( status == `it_none` ) ? `it_collected` : ( status == `it_collected` ) ? `it_skipped` : `it_none`; 
        if ( status == `it_none` ){
            items.editSingleField(uid, `status`, `it_collected`);
            items.editSingleField(uid, `collected`, true);
        }else if( status == `it_collected` ){
            items.editSingleField(uid, `status`, `it_skipped`);
            items.editSingleField(uid, `collected`, false);
        }else{
            items.editSingleField(uid, `status`, `it_none`);
        }
    };

    const completeTrip = async () => {
        const itemsToRemove = $items.filter( item => ( item.status === `it_collected` || item.status === `it_skipped` ));
        itemsToRemove.forEach(async item => {
            await items.editSingleField(item.uid, `listUid`, ``);
        });
        await idb.save(`pc_items`, $items);
        await items.init(list_uid, `listUid`);
        page.back('/lists')
    };

    $: if($lists && $items){
        if ( $items.length === 0 ) {
            lists.editSingleField(list_uid, 'progress', 0);
        } else {
            progress = Math.round( ($items.filter( item => ( item.status === `it_collected` || item.status === `it_skipped` ) && item.listUid == list_uid ).length / $items.length ) * 100 );
            lists.editSingleField(list_uid, 'progress', progress);
            console.group(`INFO: lists/items $`);console.log(progress,$lists,$items);console.groupEnd();
            categoriesInList = {};
            $items.forEach(item => {
                categoriesInList[item.category]=true;
            });
        }
    }

    onDestroy(() => {
        idb.save('pc_items', $items);
        idb.save('pc_lists', $lists);
        console.group(`INFO: lists/items .onDestroy`);console.log($lists);console.groupEnd();
    });
</script>

<section id="list" in:fly="{{ x: back_nav ? -250 : 250, duration: 150 }}" out:fly="{{ x: 250, duration: 150, delay:150 }}" class="flex flex-col justify-between bg-primary fixed top-0 left-0 h-screen w-screen px-10">
    {#each $lists as list}    
        <section id="top-bar" class="flex mt-12 justify-between">
            <div id="back-btn" class="place-self-center" on:click={() => page.back('/lists')} >
                <svg viewBox="0 0 18 18" class="fill-secondary h-5" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
                </svg>
            </div>
            <div id="title" class="place-self-center capitalize" on:click|stopPropagation={() => page.route('/lists/items/store?list_uid='+list.uid)}>{list.storeName}</div>
            <div id="title-menu" class="place-self-center" on:click|stopPropagation={() => modal.open(`/menu-lists-items?list_uid=${list_uid}&store_name=${list.storeName}&store_logo=${list.storeLogo}&anchor=top`)}>
                <svg class="fill-secondary h-5" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"/>
                    <path d="M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z"/>
                    <path d="M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5Z"/>
                </svg>
            </div>
        </section>
        <section id="progress-bar" class="mt-10 flex">
            <svg viewBox="0 0 280 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect rx="2.5" class="fill-shade w-full h-1.5"/>
                <rect style="width:{progress}%; transition: width .66s" rx="2.5" class="fill-secondary h-1.5"/>
            </svg>
        </section>

        <section class="flex justify-end" on:click|stopPropagation={()=>{page.route('/lists/items/item-generic?list_uid='+list_uid)}}>  
            <Icon name="add" width="18"/> 
            <span class="text-secondary text-sm italic pt-0.5">Add item</span>
        </section>

        <section id="main" class="mt-4 flex flex-col space-y-10 grow overflow-auto no-scrollbar">
            {#each $categories as category}
            {#if categoriesInList[category]}
                <section class="category">
                    <section class="cat-icon">
                        <img class="h-12 m-auto" src="/img/icon/food/{category}.png" alt=""/>
                    </section>
                    <section class="cat-name font-bold text-2xl text-center capitalize mt-2.5">
                        <span>{category}</span>
                    </section>
                    <section class="cat-items mt-6 flex flex-col space-y-6">
                        {#if $items}
                            {#each $items as item}
                                {#if item.category == category}
                                <section class="flex items-stretch" on:click|stopPropagation={()=>modal.open(`/update-item?list_uid=${list_uid}&item_uid=${item.uid}&store_uid=${list.storeUid}&store_name=${list.storeName}&selected_date=${item.next}&anchor=bottom`)}>
                                    <section class="item-start w-10 shrink-0 text-right place-self-center">
                                        <span class="text-shade text-sm">{item.qty}{item.unit}</span>
                                    </section>
                                    <section class="item-name ml-3.5 capitalize grow">
                                        <span class:strikeText={ item.status === `it_collected` || item.status === `it_skipped` } class="strikeText" >{item.name}</span>
                                        {#if item.cut }
                                            <span class="text-xs italic ">{item.cut}</span>
                                        {/if}
                                        <div class="flex space-x-1">
                                            {#each item.options as options }
                                            {#each Object.entries(options) as [key, exist] }
                                            {#if exist }
                                                <span class="text-xs italic">{key}</span>
                                            {/if}
                                            {/each}
                                        {/each}
                                        </div>
                                       
                                    </section>
                                    <section class="item-end flex"  on:click|stopPropagation="{() => changeItemStatus(item.uid, item.status)}">
                                        <!--input type="checkbox" id="item-collected-{item.uid}" bind:checked={item.collected}/>
                                        <label for="item-collected-{item.uid}" class="pr-6 before:mt-1 before:w-5 before:h-3.5"></label-->
                                        <Icon name={item.status} />
                                    </section>
                                </section>
                                {/if}
                            {/each}
                        {/if}   
                    </section>
                </section>
            {/if}
            {/each}
            <section class="h-12"></section>
        </section>
        <section id="footer" class="m-auto my-12" on:click={completeTrip} >
            Complete trip
        </section>
    {/each}
</section>

<style>
</style>